import React from "react";

import { useTranslation } from "utils";

import { Steps } from "components";

export const ONBOARDING_STEP_COUNT = 3;

export const OnboardingSteps = ({ current }: { current: number }) => {
  const { t } = useTranslation("scenarioAnalysis");

  const items = Array.from({ length: ONBOARDING_STEP_COUNT }, (_, index) => ({
    title: t(`onboarding.progress.step${index + 1}`),
  }));

  return (
    <div className="onboarding-steps">
      <Steps current={current} items={items} size="small" labelPlacement="horizontal" />
    </div>
  );
};
